import { render } from "./MarketingSection.vue?vue&type=template&id=598c65ec&scoped=true"
import script from "./MarketingSection.vue?vue&type=script&lang=js"
export * from "./MarketingSection.vue?vue&type=script&lang=js"

import "./MarketingSection.vue?vue&type=style&index=0&id=598c65ec&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-598c65ec"]])

export default __exports__